
import axios from 'axios';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardFooter,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBListGroup, MDBListGroupItem,
  MDBModal, MDBModalBody,
  MDBRow,
  MDBSelect,
  MDBTooltip,
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { fetchMainPageData } from '../../utils/Common';
import { NavbarContext } from '../../context/NavProvider';
import { GeographyContext } from '../../context/GeographyProvider';
function CreateThumbnail({ product }) {
  const {ipAddress} = useContext(GeographyContext);
  const { setIsPricing,setPageData,pageData,setBusiness} = useContext(NavbarContext);
 

 /* global FB */

  const domainIdFromLocalStorage = localStorage.getItem('DOMAIN');
  const [selectValue, setSelectValue] = useState([]);
  const [selectValueForThumbNail, setSelectValueForThumbNail] = useState([]);
  
  const [availableList, setAvailableList] = useState([]);
  const [entities, setEntities] = useState([]);
  const [images, setImages] = useState([]);
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;
  const [basicModal, setBasicModal] = useState(false);
  const [shareUrl, setShareUrl] = useState("");

  const toggleShow = () => setBasicModal(!basicModal);
  const getIPAddress = useCallback(() => {
    return ipAddress || localStorage.getItem('ipAddress');
},[ipAddress])
  const fetchEntities = useCallback(async () => {
    try {
      const response = await axios.get(`${baseUrl}/entities/domainId/${domainIdFromLocalStorage}?ipAddress=${getIPAddress()}`);
      if (response.status === 200) {
        setEntities(response.data);
      }
    } catch (error) {
      setEntities([]);
      console.error(error);
    }
  }, [baseUrl, domainIdFromLocalStorage, getIPAddress]);
  

  useEffect(() => {
    if (!pageData) {
      fetchMainPageData(setPageData,setIsPricing,pageData,setBusiness);
      
    }
    fetchEntities();
  }, []);
  
  

  const fetchImage = useCallback(async () => {
    try {
     
      const response = await axios.get(`${baseUrl}/imgs`);
      if (response.status === 200) {
        setImages(response.data);
      }
    }
    catch (error) {
      setImages(null);
      console.error(error);
    }
  },[baseUrl]);
  useEffect(() => {
    fetchImage();
  }, [fetchImage]);


  const transformedData = (images && images.length > 0) ? 
  images.map(image => ({
    text: image.name,
    icon: image.thumbnail
  }))
: [];

  const transformedEntities = entities.map(entity => ({
    name: entity.name,
    imageUrl: entity?.thumbnails && entity.thumbnails.length>0 &&Array.from(entity.thumbnails)[0], // grabbing the first image from the set
    discountedPrice: entity.discountedPrice,
    price: entity.originalPrice,
    currencySymbol: entity.currencySymbol,
  }));
  const shareOnFacebookSDK = () => {
    FB.ui({
      method: 'share_open_graph',
      action_type: 'og.shares',
      action_properties: JSON.stringify({
        object: {
          'og:url': 'https://bheemfoods.com',
          'og:title': 'Diwali Sweets',
          'og:description': 'sharing',
          'og:image': 'https://bheemfoods.com/products'
        }
      })
    }, function(response){});
  }
  
  const shareOnFacebookModal = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=https://bheemfoods.com`;
    setShareUrl(url);
    toggleShow();
  }
  

  return (
    <>
    <MDBModal open={basicModal} setOpen={setBasicModal} tabIndex='-1'>
          <MDBModalBody>
       <iframe src={shareUrl}   className="min-vw-100"  title="facebook add"></iframe>
    </MDBModalBody>
    
          </MDBModal>
    <MDBContainer className="text-center justify-content-center align-items-center mt-3 grainy-gradient-intro">


  <MDBRow className='d-flex row-cols-1 row-cols-md-2 g-1 justify-content-center mt-2'>
 <MDBCol xs='12' sm='6' md='6' lg='6' xl='6' className=' justify-content-center'>
 <MDBSelect  label='select for carousel'
   
    data={transformedData}

    multiple  
    value={selectValue}
    onValueChange={(e) => {
      console.log("Event Value: ", e);
      if (Array.isArray(e)) {
        const selectedValues = e.map(item => item.value);
        setSelectValue(selectedValues);
        
      }
    }}
/>
<MDBSelect className='mt-2' label='select for thumbnail'
    data={transformedData} 
  
    value={selectValueForThumbNail}
    onValueChange={(e) => {
      console.log("Event Value for single: ", e);
      setSelectValueForThumbNail(e?.value);
    }}
/>
<MDBSelect 
  className='mt-2' 
  label='Select from available list'
  data={transformedEntities.map(entity => ({
    text: `${entity.name} - ${entity.currencySymbol}${entity.price}`,
    value: entity.name,
    icon: entity.imageUrl
  }))}
  multiple
  value={availableList}
  onValueChange={(e) => {
    console.log("Event Value for transformedEntities: ", e);
    if (Array.isArray(e)) {
    const selectedList = e.map(item => item.value);
    setAvailableList(selectedList);
    }
  }}
/>


</MDBCol>
<MDBCol xs='12' sm='6' md='6' lg='6' xl='6' className=' justify-content-center'>
{/* <MDBDraggable className='shadow-1-strong' draggingClass='shadow-3-strong'> */}

<MDBCard className="m-2"  cascade ecommerce wide>
  <MDBCardBody>
    <MDBListGroup flush>
      {availableList?.map(name => {
        const entity = transformedEntities.find(e => e.name === name);
        return (
          <MDBListGroupItem key={name} className='d-flex text-start '>
            <MDBRow><MDBCol className='d-flex  text-start '> <img src={entity?.imageUrl} alt={entity?.name} width="50" height="50" className='d-flex me-3 rounded'/></MDBCol>
            
            <MDBCol className='d-flex me-3 text-start '>
              
            <span className='mt-2 me-3 '>{entity?.name}</span> 
           <span className='mt-2 me-3 '>{entity?.currencySymbol}
            <del>{entity.price}</del> </span>
            <span className='mt-2 me-3'> {entity?.currencySymbol}
            <mark>{entity.discountedPrice}</mark></span>
              </MDBCol>
              
              </MDBRow>
           
        
          
          </MDBListGroupItem>



        );
      })}
    </MDBListGroup>
  </MDBCardBody>
 




<MDBCardFooter>
  <div className=" d-flex align-items-center float-end">
    <span className="mr-3 me-3">
      <MDBTooltip tag='a' wrapperProps={{ href: 'https://bheemfoods.com' }} title="go to bheemfood.com" placement="top">
        <MDBIcon icon="shopping-cart" /><div>buy now</div>
      </MDBTooltip>
    </span>
    <span className="mr-3 me-3">
    <MDBBtn floating size='sm' tag='a' color='none' onClick={shareOnFacebookSDK}>
        <MDBIcon fab icon="facebook" /><div>Facebook</div>
    </MDBBtn>
</span>

    {/* <span className="mr-3 me-3">
 
  <MDBBtn floating onClick={shareOnFacebookModal} size='sm' tag='a' color='none'>
        <MDBIcon fab icon='facebook-f' />
      </MDBBtn>

</span> */}


    <span  className="mr-3 me-3">
      <MDBTooltip tag='a' wrapperProps={{ href: 'https://api.whatsapp.com/send?text=https://bheemfoods.com' }} title="Share on WhatsApp" placement="top">
        <MDBIcon fab icon="whatsapp" /><div>WhatsApp</div>
      </MDBTooltip>
    </span>
    <span  className="mr-3">
      <MDBTooltip tag='a' wrapperProps={{ href: 'https://bheemfoods.com' }} title="go to bheemfood.com" placement="top">
        <MDBIcon icon="share-alt" /><div>Share</div>
      </MDBTooltip>
    </span>
  </div>
</MDBCardFooter>



  
</MDBCard>



    {/* </MDBDraggable> */}
  
    </MDBCol>  
   
    </MDBRow>
   
    </MDBContainer>
    </>
  );
}

CreateThumbnail.propTypes = {
    product: PropTypes.object,
  };

export default CreateThumbnail;
